var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-swiper" },
    [
      _c("div", { staticClass: "swiper-container gallery-top" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.images, function(image, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "swiper-slide lazyload",
                attrs: { "data-sizes": "auto" },
                on: {
                  click: function($event) {
                    return _vm.toggleModal(image)
                  }
                }
              },
              [_c("v-image", { attrs: { src: image } })],
              1
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-container gallery-thumbs" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.images, function(image, index) {
            return _c("div", {
              key: index,
              staticClass: "swiper-slide lazyload",
              attrs: { "data-sizes": "auto", "data-bgset": image }
            })
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("v-lightbox", {
        attrs: { openModal: _vm.openModal, src: _vm.activeSlide },
        on: { close: _vm.toggleModal }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-prev" }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-next" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }